import { Empty, Spin } from "antd";
import { WidgetEmpty } from "components/widgets/WidgetEmpty";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import GlobalSettingAPI from "restAPI/GlobalSettingAPI";
import ProductAPI from "restAPI/ProductAPI";
import { ConfigCard } from "views/GlobalSettings/FindingSLAConfigurationV2";

export default function SLAPreview({
  slaID,
  productID,
  subProductID,
  emptyMessage,
  loading = false,
  viewOnly = false,
}) {
  const [slaData, setSlaData] = useState();
  const isSlaID = !_.isUndefined(slaID) && !_.isNull(slaID);

  const fetchSLAData = useCallback(() => {
    setSlaData();

    if (isSlaID) {
      const { promise, cancel } = GlobalSettingAPI.getSLADetails(slaID);
      promise.then(setSlaData);
      return cancel;
    } else {
      const params = {
        product: productID,
        subproduct: subProductID,
      };
      const { promise, cancel } = ProductAPI.getFindingSLADetails(params);

      promise.then(setSlaData);
      return cancel;
    }
  }, [slaID, isSlaID, productID, subProductID]);

  useEffect(() => {
    if (!loading) {
      fetchSLAData();
    }
  }, [fetchSLAData, loading]);

  return (
    <div className="m-b-m">
      {
        <Spin spinning={_.isUndefined(slaData) || loading}>
          {_.isUndefined(slaData) ? (
            <WidgetEmpty
              icon={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                emptyMessage ?? (
                  <>
                    <div>Seems like you haven't selected the SLA.</div>
                    <div>Please select the SLA from the dropdown.</div>
                  </>
                )
              }
            />
          ) : (
            <>
              {_.isEmpty(slaData) ? (
                <div className="m-b-m">
                  <strong>No SLA Available</strong>
                </div>
              ) : (
                <>
                  {!isSlaID && (
                    <div className="m-b-m">
                      <strong>
                        No SLA selected. Below SLA will be applicable by
                        default.
                      </strong>
                      <br />
                    </div>
                  )}
                  <ConfigCard
                    data={slaData}
                    hideDesc={true}
                    viewOnly={viewOnly}
                  />
                </>
              )}
            </>
          )}
        </Spin>
      }
    </div>
  );
}
